export default __webpack_public_path__ + "images/304c3e226fb6615016e549c09e6df62a.svg";